/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCompanyApiKeyFromJSON, StreemApiCompanyApiKeyToJSON, } from './';
export function StreemApiAuthIdentityCompanyApiKeyFromJSON(json) {
    return StreemApiAuthIdentityCompanyApiKeyFromJSONTyped(json, false);
}
export function StreemApiAuthIdentityCompanyApiKeyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'companyApiKey': !exists(json, 'company_api_key') ? undefined : StreemApiCompanyApiKeyFromJSON(json['company_api_key']),
    };
}
export function StreemApiAuthIdentityCompanyApiKeyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'company_api_key': StreemApiCompanyApiKeyToJSON(value.companyApiKey),
    };
}
//# sourceMappingURL=StreemApiAuthIdentityCompanyApiKey.js.map